/* @flow */
import * as React from 'react';
import Image from 'components/Image.jsx';
import Input from 'components/Input.jsx';
import './UsersSmsInviteInstructionsPhone.scss';

type Props = {
  code: ?string,
  number: ?string,
};

export default function UsersSmsInviteInstructionsPhone({ code, number }: Props) {
  const inputId = 'UsersSmsInviteInstructionsPhone-inputId';
  return (
    <div className="UsersSmsInviteInstructionsPhone">
      <Image
        className="UsersSmsInviteInstructionsPhone-image"
        src={require('assets/images/GroupInviteModal/phone.svg')}
      />
      <div className="UsersSmsInviteInstructionsPhone-to">
        <div className="UsersSmsInviteInstructionsPhone-to-inner">
          {/* eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */}
          <label
            htmlFor={inputId}
            className="UsersSmsInviteInstructionsPhone-to-label UsersSmsInviteInstructionsPhone-label">
            To:
          </label>
          <div className="UsersSmsInviteInstructionsPhone-to-number">
            <Input
              id={inputId}
              value={number}
              readOnly
              className="UsersSmsInviteInstructionsPhone-input"
            />
          </div>
        </div>
      </div>
      <div className="UsersSmsInviteInstructionsPhone-message">
        @{code}
        <div className="UsersSmsInviteInstructionsPhone-message-bubble-arrow" />
      </div>
      <div className="UsersSmsInviteInstructionsPhone-send">Send</div>
    </div>
  );
}
